import "core-js/modules/es6.array.find";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { Parameters } from '../../models';
export var BaseQuery =
/*#__PURE__*/
function () {
  function BaseQuery(config, queryService) {
    _classCallCheck(this, BaseQuery);

    this.config = config;
    this.queryService = queryService;
    this.parameters = [];
  }
  /**
   * Adds custom parameter to query
   * @param name Name of parameter
   * @param value Value of parameter
   */


  _createClass(BaseQuery, [{
    key: "withCustomParameter",
    value: function withCustomParameter(name, value) {
      this.parameters.push(new Parameters.QueryParameter(name, value));
      return this;
    }
    /**
     * Adds parameter to query
     * @param name Name of parameter
     * @param value Value of parameter
     */

  }, {
    key: "withParameter",
    value: function withParameter(parameter) {
      this.parameters.push(parameter);
      return this;
    }
    /**
     * Adds parameters to query
     * @param parameters Array of parameters
     */

  }, {
    key: "withParameters",
    value: function withParameters(parameters) {
      var _this$parameters;

      (_this$parameters = this.parameters).push.apply(_this$parameters, _toConsumableArray(parameters));

      return this;
    }
    /**
     * Gets headers used by this query
     */

  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return this.queryService.getHeaders(this._queryConfig, []);
    }
    /**
     * Sets request headers
     */

  }, {
    key: "withHeaders",
    value: function withHeaders(headers) {
      var _a;

      var queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
      queryHeaders.push.apply(queryHeaders, _toConsumableArray(headers));
      this._queryConfig.customHeaders = queryHeaders;
      return this;
    }
    /**
     * Sets request header
     */

  }, {
    key: "withHeader",
    value: function withHeader(header) {
      var _a;

      var queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
      queryHeaders.push(header);
      this._queryConfig.customHeaders = queryHeaders;
      return this;
    }
    /**
     * Sets custom URL of request (overrides default URL of the query)
     */

  }, {
    key: "withCustomUrl",
    value: function withCustomUrl(url) {
      this.customUrl = url;
      return this;
    }
    /**
     * Gets all query parameter currently applied to query
     */

  }, {
    key: "getParameters",
    value: function getParameters() {
      return this.parameters;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */

  }, {
    key: "queryConfig",
    value: function queryConfig(_queryConfig) {
      this._queryConfig = _queryConfig;
      return this;
    }
  }, {
    key: "resolveUrlInternal",
    value: function resolveUrlInternal(action) {
      var _a; // use custom URL if user specified it


      if (this.customUrl) {
        return this.customUrl;
      } // use original url


      return this.queryService.getUrl(action, (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {}, this.getParameters());
    }
  }, {
    key: "processDefaultLanguageParameter",
    value: function processDefaultLanguageParameter() {
      // add default language if none is specified && default language is specified globally
      if (this.config.defaultLanguage) {
        var languageParameter = this.getParameters().find(function (m) {
          return m.getParam() === 'language';
        });

        if (!languageParameter) {
          // language parameter was not specified in query, use globally defined language
          this.parameters.push(new Parameters.LanguageParameter(this.config.defaultLanguage));
        }
      }
    }
  }]);

  return BaseQuery;
}();